import { render, staticRenderFns } from "./accreditationAgencyImport.vue?vue&type=template&id=558d0e0c&scoped=true"
import script from "./accreditationAgencyImport.vue?vue&type=script&lang=js"
export * from "./accreditationAgencyImport.vue?vue&type=script&lang=js"
import style0 from "./accreditationAgencyImport.vue?vue&type=style&index=0&id=558d0e0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558d0e0c",
  null
  
)

export default component.exports